import React, { useState } from "react";
import {
  Box,
  Button,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  TablePagination,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Card,
  CardContent,
  Grid,
  InputAdornment,
  Chip,
  Tooltip,
  Alert,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Avatar,
  Badge,
  Switch,
  FormControlLabel,
} from "@mui/material";
import {
  Edit as EditIcon,
  Delete as DeleteIcon,
  Search as SearchIcon,
  Add as AddIcon,
  Receipt as PriceListIcon,
  Info as InfoIcon,
  Refresh as RefreshIcon,
  Visibility as ViewIcon,
  LocalOffer as TagIcon,
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
  AttachMoney as MoneyIcon,
  ShoppingCart as ProductIcon,
  People as PeopleIcon,
  Store as StoreIcon,
  Star as StarIcon,
  Percent as PercentIcon,
  CalendarToday as CalendarIcon,
  TrendingUp as TrendingUpIcon,
} from "@mui/icons-material";

const PriceListMaster = () => {
  const [priceListData, setPriceListData] = useState([
    { 
      id: 1, 
      priceListCode: "PL001",
      priceListName: "Retail Price", 
      priceListType: "Retail",
      discount: 0,
      validFrom: "2024-01-01",
      validTo: "2024-12-31",
      description: "Standard retail pricing for walk-in customers",
      productCount: 185,
      status: "Active",
      isDefault: true,
      priority: 1,
      currency: "INR",
      roundingMethod: "Normal",
      createdDate: "2024-01-01",
      updatedDate: "2024-01-01"
    },
    { 
      id: 2, 
      priceListCode: "PL002",
      priceListName: "Wholesale Price", 
      priceListType: "Wholesale",
      discount: 15,
      validFrom: "2024-01-01",
      validTo: "2024-12-31",
      description: "Wholesale pricing for bulk purchases",
      productCount: 145,
      status: "Active",
      isDefault: false,
      priority: 2,
      currency: "INR",
      roundingMethod: "Down",
      createdDate: "2024-01-01",
      updatedDate: "2024-01-01"
    },
    { 
      id: 3, 
      priceListCode: "PL003",
      priceListName: "Member Price", 
      priceListType: "Member",
      discount: 10,
      validFrom: "2024-01-01",
      validTo: "2024-12-31",
      description: "Special pricing for loyalty members",
      productCount: 165,
      status: "Active",
      isDefault: false,
      priority: 3,
      currency: "INR",
      roundingMethod: "Normal",
      createdDate: "2024-01-01",
      updatedDate: "2024-01-01"
    },
    { 
      id: 4, 
      priceListCode: "PL004",
      priceListName: "VIP Customer Price", 
      priceListType: "VIP",
      discount: 20,
      validFrom: "2024-01-01",
      validTo: "2024-12-31",
      description: "Premium pricing for VIP customers",
      productCount: 125,
      status: "Active",
      isDefault: false,
      priority: 4,
      currency: "INR",
      roundingMethod: "Normal",
      createdDate: "2024-01-01",
      updatedDate: "2024-01-01"
    },
    { 
      id: 5, 
      priceListCode: "PL005",
      priceListName: "Distributor Price", 
      priceListType: "Distributor",
      discount: 25,
      validFrom: "2024-01-01",
      validTo: "2024-12-31",
      description: "Pricing for authorized distributors",
      productCount: 95,
      status: "Active",
      isDefault: false,
      priority: 5,
      currency: "INR",
      roundingMethod: "Down",
      createdDate: "2024-01-01",
      updatedDate: "2024-01-01"
    },
    { 
      id: 6, 
      priceListCode: "PL006",
      priceListName: "Seasonal Discount", 
      priceListType: "Promotional",
      discount: 30,
      validFrom: "2024-06-01",
      validTo: "2024-08-31",
      description: "Summer sale pricing",
      productCount: 85,
      status: "Active",
      isDefault: false,
      priority: 6,
      currency: "INR",
      roundingMethod: "Normal",
      createdDate: "2024-01-01",
      updatedDate: "2024-01-01"
    },
    { 
      id: 7, 
      priceListCode: "PL007",
      priceListName: "Corporate Bulk Price", 
      priceListType: "Corporate",
      discount: 18,
      validFrom: "2024-01-01",
      validTo: "2024-12-31",
      description: "Corporate bulk purchase pricing",
      productCount: 105,
      status: "Active",
      isDefault: false,
      priority: 7,
      currency: "INR",
      roundingMethod: "Down",
      createdDate: "2024-01-01",
      updatedDate: "2024-01-01"
    },
    { 
      id: 8, 
      priceListCode: "PL008",
      priceListName: "Clearance Sale", 
      priceListType: "Clearance",
      discount: 50,
      validFrom: "2024-03-01",
      validTo: "2024-03-31",
      description: "End of season clearance pricing",
      productCount: 45,
      status: "Active",
      isDefault: false,
      priority: 8,
      currency: "INR",
      roundingMethod: "Normal",
      createdDate: "2024-01-01",
      updatedDate: "2024-01-01"
    },
    { 
      id: 9, 
      priceListCode: "PL009",
      priceListName: "Export Price", 
      priceListType: "Export",
      discount: 12,
      validFrom: "2024-01-01",
      validTo: "2024-12-31",
      description: "Pricing for export customers",
      productCount: 55,
      status: "Active",
      isDefault: false,
      priority: 9,
      currency: "USD",
      roundingMethod: "Up",
      createdDate: "2024-01-01",
      updatedDate: "2024-01-01"
    },
    { 
      id: 10, 
      priceListCode: "PL010",
      priceListName: "Festival Special", 
      priceListType: "Promotional",
      discount: 40,
      validFrom: "2023-11-01",
      validTo: "2023-11-30",
      description: "Diwali special pricing",
      productCount: 0,
      status: "Expired",
      isDefault: false,
      priority: 10,
      currency: "INR",
      roundingMethod: "Normal",
      createdDate: "2023-10-01",
      updatedDate: "2023-10-01"
    },
  ]);

  const [searchQuery, setSearchQuery] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [typeFilter, setTypeFilter] = useState("all");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [successMessage, setSuccessMessage] = useState("");
  const [errors, setErrors] = useState({});

  // Modal state
  const [openModal, setOpenModal] = useState(false);
  const [openViewModal, setOpenViewModal] = useState(false);
  const [editingPriceList, setEditingPriceList] = useState(null);
  const [viewingPriceList, setViewingPriceList] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [newPriceList, setNewPriceList] = useState({
    priceListCode: "",
    priceListName: "",
    priceListType: "Retail",
    discount: 0,
    validFrom: "",
    validTo: "",
    description: "",
    status: "Active",
    isDefault: false,
    priority: 1,
    currency: "INR",
    roundingMethod: "Normal",
  });

  // Get unique types for filter
  const priceListTypes = [...new Set(priceListData.map(p => p.priceListType))];

  // Helper functions
  const getFilteredPriceLists = () => {
    return priceListData.filter((priceList) => {
      const matchesSearch = Object.values(priceList).some((value) =>
        String(value).toLowerCase().includes(searchQuery.toLowerCase())
      );
      const matchesStatus = statusFilter === "all" || priceList.status === statusFilter;
      const matchesType = typeFilter === "all" || priceList.priceListType === typeFilter;
      return matchesSearch && matchesStatus && matchesType;
    });
  };

  const getStatusStyle = (status) => {
    switch (status) {
      case 'Active':
        return { backgroundColor: '#e8f5e9', color: '#2e7d32' };
      case 'Expired':
        return { backgroundColor: '#ffebee', color: '#d32f2f' };
      case 'Inactive':
        return { backgroundColor: '#fff3e0', color: '#e65100' };
      default:
        return { backgroundColor: '#f5f5f5', color: '#666' };
    }
  };

  const getTypeColor = (type) => {
    switch (type) {
      case 'Retail': return 'primary';
      case 'Wholesale': return 'secondary';
      case 'Member': return 'success';
      case 'VIP': return 'error';
      case 'Distributor': return 'info';
      case 'Corporate': return 'warning';
      case 'Promotional': return 'error';
      case 'Clearance': return 'warning';
      case 'Export': return 'info';
      default: return 'default';
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!newPriceList.priceListName.trim()) newErrors.priceListName = 'Price list name is required';
    if (!newPriceList.priceListType.trim()) newErrors.priceListType = 'Price list type is required';
    if (newPriceList.discount === undefined || newPriceList.discount < 0 || newPriceList.discount > 100) {
      newErrors.discount = 'Discount must be between 0 and 100';
    }
    if (!newPriceList.validFrom) newErrors.validFrom = 'Valid from date is required';
    if (!newPriceList.validTo) newErrors.validTo = 'Valid to date is required';
    if (newPriceList.validFrom && newPriceList.validTo && newPriceList.validFrom > newPriceList.validTo) {
      newErrors.validTo = 'Valid to date must be after valid from date';
    }
    if (!newPriceList.priority || newPriceList.priority <= 0) {
      newErrors.priority = 'Priority must be greater than 0';
    }
    return newErrors;
  };

  // Handlers
  const handleEdit = (priceList) => {
    setEditingPriceList(priceList);
    setNewPriceList({ ...priceList });
    setOpenModal(true);
  };

  const handleView = (priceList) => {
    setViewingPriceList(priceList);
    setOpenViewModal(true);
  };

  const handleDelete = (id) => {
    const priceListToDelete = priceListData.find(p => p.id === id);
    
    if (priceListToDelete.isDefault) {
      alert("Cannot delete default price list. Please set another price list as default first.");
      return;
    }

    if (priceListToDelete.productCount > 0) {
      alert(`Cannot delete price list with ${priceListToDelete.productCount} products. Please reassign or delete products first.`);
      return;
    }

    if (window.confirm("Are you sure you want to delete this price list?")) {
      setPriceListData(priceListData.filter((priceList) => priceList.id !== id));
      setSuccessMessage("Price list deleted successfully!");
      setTimeout(() => setSuccessMessage(""), 3000);
    }
  };

  const handleChangePage = (_, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Search and filter handlers
  const handleSearch = () => {
    setPage(0);
    setSuccessMessage(`Search completed. Found ${getFilteredPriceLists().length} price lists.`);
    setTimeout(() => setSuccessMessage(""), 3000);
  };

  const handleReset = () => {
    setSearchQuery("");
    setStatusFilter("all");
    setTypeFilter("all");
    setPage(0);
    setErrors({});
    setSuccessMessage("");
  };

  const handleOpenModal = () => {
    setEditingPriceList(null);
    setNewPriceList({
      priceListCode: "",
      priceListName: "",
      priceListType: "Retail",
      discount: 0,
      validFrom: "",
      validTo: "",
      description: "",
      status: "Active",
      isDefault: false,
      priority: 1,
      currency: "INR",
      roundingMethod: "Normal",
    });
    setErrors({});
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setEditingPriceList(null);
    setErrors({});
  };

  const handleCloseViewModal = () => {
    setOpenViewModal(false);
    setViewingPriceList(null);
  };

  const handleInputChange = (e) => {
    const { name, value, checked, type } = e.target;
    setNewPriceList({ 
      ...newPriceList, 
      [name]: type === 'checkbox' ? checked : value 
    });
    if (errors[name]) {
      setErrors({ ...errors, [name]: "" });
    }
  };

  const handleAddPriceList = async () => {
    const formErrors = validateForm();
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      return;
    }

    setIsLoading(true);
    try {
      if (editingPriceList) {
        // Update existing price list
        setPriceListData(priceListData.map(priceList => 
          priceList.id === editingPriceList.id 
            ? { 
                ...priceList, 
                ...newPriceList,
                discount: parseFloat(newPriceList.discount),
                updatedDate: new Date().toISOString().split('T')[0]
              }
            : priceList
        ));
        setSuccessMessage("Price list updated successfully!");
      } else {
        // Add new price list
        const newId = priceListData.length > 0 ? Math.max(...priceListData.map(p => p.id)) + 1 : 1;
        const priceListCode = `PL${String(newId).padStart(3, '0')}`;
        setPriceListData([...priceListData, { 
          id: newId, 
          ...newPriceList,
          priceListCode: newPriceList.priceListCode || priceListCode,
          discount: parseFloat(newPriceList.discount),
          productCount: 0,
          createdDate: new Date().toISOString().split('T')[0],
          updatedDate: new Date().toISOString().split('T')[0]
        }]);
        setSuccessMessage("Price list added successfully!");
      }
      handleCloseModal();
    } catch (error) {
      setErrors({ general: "An error occurred. Please try again." });
    } finally {
      setIsLoading(false);
      setTimeout(() => setSuccessMessage(""), 3000);
    }
  };

  const filteredPriceLists = getFilteredPriceLists();

  // Calculate statistics
  const totalPriceLists = priceListData.length;
  const activePriceLists = priceListData.filter(p => p.status === "Active").length;
  const defaultPriceList = priceListData.find(p => p.isDefault);
  const totalProducts = priceListData.reduce((sum, priceList) => sum + priceList.productCount, 0);
  const avgDiscount = (priceListData.reduce((sum, priceList) => sum + priceList.discount, 0) / priceListData.filter(p => p.discount > 0).length).toFixed(1);

  return (
    <Box sx={{ p: 3 }}>
      {/* Header Section */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Badge badgeContent={totalPriceLists} color="primary">
            <PriceListIcon sx={{ color: 'primary.main', fontSize: 40 }} />
          </Badge>
          <Box>
            <Typography variant="h4" fontWeight="bold" color="primary">
              Price List Master Management
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Manage pricing strategies and customer price lists • {filteredPriceLists.length} price lists found
            </Typography>
          </Box>
        </Box>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={handleOpenModal}
          sx={{
            borderRadius: 2,
            px: 3,
            py: 1,
            fontWeight: 600,
            backgroundColor: 'primary.main',
            '&:hover': {
              backgroundColor: 'primary.dark',
            },
          }}
        >
          Add New Price List
        </Button>
      </Box>

      {/* Success Message */}
      {successMessage && (
        <Alert severity="success" sx={{ mb: 2, borderRadius: 2 }}>
          {successMessage}
        </Alert>
      )}

      {/* Search and Filter Section */}
      <Paper sx={{ p: 3, mb: 3, borderRadius: 2, boxShadow: 2 }}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="Search Price Lists..."
              variant="outlined"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} md={2.5}>
            <TextField
              select
              fullWidth
              label="Filter by Type"
              value={typeFilter}
              onChange={(e) => setTypeFilter(e.target.value)}
              SelectProps={{
                native: true,
              }}
            >
              <option value="all">All Types</option>
              {priceListTypes.map((type) => (
                <option key={type} value={type}>{type}</option>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12} md={2.5}>
            <TextField
              select
              fullWidth
              label="Status"
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
              SelectProps={{
                native: true,
              }}
            >
              <option value="all">All Status</option>
              <option value="Active">Active</option>
              <option value="Expired">Expired</option>
              <option value="Inactive">Inactive</option>
            </TextField>
          </Grid>
          <Grid item xs={12} md={3}>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <Button
                variant="contained"
                onClick={handleSearch}
                startIcon={<SearchIcon />}
                sx={{ flex: 1 }}
              >
                Search
              </Button>
              <Button
                variant="outlined"
                onClick={handleReset}
                startIcon={<RefreshIcon />}
                sx={{ flex: 1 }}
              >
                Reset
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Paper>

      {/* Table Section */}
      <Paper sx={{ borderRadius: 2, boxShadow: 3, overflow: 'hidden' }}>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow sx={{ backgroundColor: '#f8f9fa' }}>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '0.95rem' }}>S.No</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '0.95rem' }}>Code</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '0.95rem' }}>Price List Name</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '0.95rem' }}>Type</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '0.95rem' }}>Discount (%)</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '0.95rem' }}>Validity Period</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '0.95rem' }}>Products</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '0.95rem' }}>Currency</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '0.95rem' }}>Default</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '0.95rem' }}>Status</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '0.95rem' }} align="center">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredPriceLists.length > 0 ? (
                filteredPriceLists
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((priceList, index) => (
                    <TableRow 
                      key={priceList.id} 
                      sx={{ 
                        '&:hover': { backgroundColor: '#f5f5f5' },
                        transition: 'background-color 0.2s',
                        backgroundColor: priceList.isDefault ? 'rgba(83, 109, 254, 0.05)' : 'inherit'
                      }}
                    >
                      <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                      <TableCell>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <TagIcon sx={{ fontSize: 18, color: 'text.secondary' }} />
                          {priceList.priceListCode}
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <Typography variant="body2" fontWeight="600">
                            {priceList.priceListName}
                          </Typography>
                          {priceList.isDefault && (
                            <StarIcon sx={{ fontSize: 18, color: 'warning.main' }} />
                          )}
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Chip 
                          label={priceList.priceListType} 
                          size="small" 
                          color={getTypeColor(priceList.priceListType)}
                          sx={{ fontWeight: 500 }}
                        />
                      </TableCell>
                      <TableCell>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                          <PercentIcon sx={{ fontSize: 16, color: 'success.main' }} />
                          <Typography variant="body2" fontWeight="600" color="success.main">
                            {priceList.discount}%
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                          <Typography variant="caption" sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                            <CalendarIcon sx={{ fontSize: 12 }} />
                            From: {priceList.validFrom}
                          </Typography>
                          <Typography variant="caption" sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                            <CalendarIcon sx={{ fontSize: 12 }} />
                            To: {priceList.validTo}
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Typography 
                          sx={{ 
                            fontWeight: 600,
                            color: priceList.productCount === 0 ? 'text.secondary' : 'primary.main'
                          }}
                        >
                          {priceList.productCount}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Chip 
                          label={priceList.currency} 
                          size="small"
                          variant="outlined"
                          sx={{ fontWeight: 600 }}
                        />
                      </TableCell>
                      <TableCell>
                        {priceList.isDefault ? (
                          <StarIcon sx={{ color: 'warning.main', fontSize: 24 }} />
                        ) : (
                          <CancelIcon sx={{ color: 'text.disabled', fontSize: 20 }} />
                        )}
                      </TableCell>
                      <TableCell>
                        <Chip
                          label={priceList.status}
                          size="small"
                          sx={{
                            ...getStatusStyle(priceList.status),
                            fontWeight: 600,
                            fontSize: '0.75rem'
                          }}
                        />
                      </TableCell>
                      <TableCell align="center">
                        <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center' }}>
                          <Tooltip title="View Details">
                            <IconButton
                              size="small"
                              onClick={() => handleView(priceList)}
                              sx={{
                                color: 'info.main',
                                '&:hover': {
                                  backgroundColor: 'info.light',
                                  transform: 'scale(1.1)',
                                },
                                transition: 'all 0.2s'
                              }}
                            >
                              <ViewIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Edit Price List">
                            <IconButton
                              size="small"
                              onClick={() => handleEdit(priceList)}
                              sx={{
                                color: 'warning.main',
                                '&:hover': {
                                  backgroundColor: 'warning.light',
                                  transform: 'scale(1.1)',
                                },
                                transition: 'all 0.2s'
                              }}
                            >
                              <EditIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Delete Price List">
                            <IconButton
                              size="small"
                              onClick={() => handleDelete(priceList.id)}
                              sx={{
                                color: 'error.main',
                                '&:hover': {
                                  backgroundColor: 'error.light',
                                  transform: 'scale(1.1)',
                                },
                                transition: 'all 0.2s'
                              }}
                              disabled={priceList.isDefault}
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))
              ) : (
                <TableRow>
                  <TableCell colSpan={11} align="center" sx={{ py: 4 }}>
                    <PriceListIcon sx={{ fontSize: 48, color: 'text.disabled', mb: 1 }} />
                    <Typography variant="body1" color="text.secondary">
                      No price lists found
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Try adjusting your search criteria or add a new price list.
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          component="div"
          count={filteredPriceLists.length}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          rowsPerPageOptions={[5, 10, 25, 50]}
        />
      </Paper>

      {/* Add/Edit Price List Modal */}
      <Dialog open={openModal} onClose={handleCloseModal} maxWidth="md" fullWidth>
        <DialogTitle sx={{
          backgroundColor: 'primary.main',
          color: 'white',
          padding: '16px 24px',
        }}>
          <Typography variant="h6" component="div" sx={{ color: 'white', display: 'flex', alignItems: 'center', gap: 1 }}>
            <PriceListIcon />
            {editingPriceList ? 'Edit Price List' : 'Add New Price List'}
          </Typography>
        </DialogTitle>
        <DialogContent sx={{ padding: '24px', mt: 2 }}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Price List Code"
                name="priceListCode"
                value={newPriceList.priceListCode}
                onChange={handleInputChange}
                helperText="Auto-generated if left empty"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <TagIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Price List Name"
                name="priceListName"
                value={newPriceList.priceListName}
                onChange={handleInputChange}
                error={!!errors.priceListName}
                helperText={errors.priceListName}
                placeholder="e.g., Retail Price, Wholesale Price"
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth error={!!errors.priceListType}>
                <InputLabel>Price List Type *</InputLabel>
                <Select
                  name="priceListType"
                  value={newPriceList.priceListType}
                  onChange={handleInputChange}
                  label="Price List Type *"
                >
                  <MenuItem value="Retail">Retail</MenuItem>
                  <MenuItem value="Wholesale">Wholesale</MenuItem>
                  <MenuItem value="Member">Member</MenuItem>
                  <MenuItem value="VIP">VIP</MenuItem>
                  <MenuItem value="Distributor">Distributor</MenuItem>
                  <MenuItem value="Corporate">Corporate</MenuItem>
                  <MenuItem value="Promotional">Promotional</MenuItem>
                  <MenuItem value="Clearance">Clearance</MenuItem>
                  <MenuItem value="Export">Export</MenuItem>
                </Select>
                {errors.priceListType && <Typography variant="caption" color="error">{errors.priceListType}</Typography>}
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Discount (%)"
                name="discount"
                type="number"
                value={newPriceList.discount}
                onChange={handleInputChange}
                error={!!errors.discount}
                helperText={errors.discount}
                inputProps={{ min: 0, max: 100, step: 0.1 }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <PercentIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Valid From"
                name="validFrom"
                type="date"
                value={newPriceList.validFrom}
                onChange={handleInputChange}
                error={!!errors.validFrom}
                helperText={errors.validFrom}
                required
                InputLabelProps={{ shrink: true }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <CalendarIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Valid To"
                name="validTo"
                type="date"
                value={newPriceList.validTo}
                onChange={handleInputChange}
                error={!!errors.validTo}
                helperText={errors.validTo}
                required
                InputLabelProps={{ shrink: true }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <CalendarIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <FormControl fullWidth>
                <InputLabel>Currency</InputLabel>
                <Select
                  name="currency"
                  value={newPriceList.currency}
                  onChange={handleInputChange}
                  label="Currency"
                >
                  <MenuItem value="INR">INR (₹)</MenuItem>
                  <MenuItem value="USD">USD ($)</MenuItem>
                  <MenuItem value="EUR">EUR (€)</MenuItem>
                  <MenuItem value="GBP">GBP (£)</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={4}>
              <FormControl fullWidth>
                <InputLabel>Rounding Method</InputLabel>
                <Select
                  name="roundingMethod"
                  value={newPriceList.roundingMethod}
                  onChange={handleInputChange}
                  label="Rounding Method"
                >
                  <MenuItem value="Normal">Normal</MenuItem>
                  <MenuItem value="Up">Round Up</MenuItem>
                  <MenuItem value="Down">Round Down</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                label="Priority"
                name="priority"
                type="number"
                value={newPriceList.priority}
                onChange={handleInputChange}
                error={!!errors.priority}
                helperText={errors.priority || "Lower number = higher priority"}
                required
                inputProps={{ min: 1 }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel>Status</InputLabel>
                <Select
                  name="status"
                  value={newPriceList.status}
                  onChange={handleInputChange}
                  label="Status"
                >
                  <MenuItem value="Active">Active</MenuItem>
                  <MenuItem value="Inactive">Inactive</MenuItem>
                  <MenuItem value="Expired">Expired</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControlLabel
                control={
                  <Switch
                    checked={newPriceList.isDefault}
                    onChange={handleInputChange}
                    name="isDefault"
                    color="warning"
                  />
                }
                label={
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <StarIcon sx={{ fontSize: 18 }} />
                    Set as Default Price List
                  </Box>
                }
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Description"
                name="description"
                value={newPriceList.description}
                onChange={handleInputChange}
                multiline
                rows={3}
                placeholder="Enter price list description..."
              />
            </Grid>
          </Grid>
          {errors.general && (
            <Alert severity="error" sx={{ mt: 2 }}>
              {errors.general}
            </Alert>
          )}
        </DialogContent>
        <DialogActions sx={{ padding: '16px 24px' }}>
          <Button onClick={handleCloseModal} disabled={isLoading}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleAddPriceList}
            disabled={isLoading}
            startIcon={isLoading ? <CircularProgress size={20} /> : <AddIcon />}
            sx={{
              backgroundColor: 'primary.main',
              '&:hover': {
                backgroundColor: 'primary.dark',
              },
            }}
          >
            {isLoading ? 'Processing...' : (editingPriceList ? 'Update Price List' : 'Add Price List')}
          </Button>
        </DialogActions>
      </Dialog>

      {/* View Price List Modal */}
      <Dialog open={openViewModal} onClose={handleCloseViewModal} maxWidth="md" fullWidth>
        <DialogTitle sx={{
          backgroundColor: 'primary.main',
          color: 'white',
          padding: '16px 24px',
        }}>
          <Typography variant="h6" component="div" sx={{ color: 'white', display: 'flex', alignItems: 'center', gap: 1 }}>
            <InfoIcon />
            Price List Details
          </Typography>
        </DialogTitle>
        <DialogContent sx={{ padding: '24px', mt: 2 }}>
          {viewingPriceList && (
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Box sx={{ textAlign: 'center', mb: 3 }}>
                  <Avatar 
                    sx={{ 
                      width: 80, 
                      height: 80, 
                      margin: '0 auto',
                      backgroundColor: 'primary.main',
                    }}
                  >
                    <PriceListIcon sx={{ fontSize: 40 }} />
                  </Avatar>
                  <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 1, mt: 2 }}>
                    <Typography variant="h5" fontWeight="bold">
                      {viewingPriceList.priceListName}
                    </Typography>
                    {viewingPriceList.isDefault && (
                      <StarIcon sx={{ color: 'warning.main', fontSize: 28 }} />
                    )}
                  </Box>
                  <Typography variant="body2" color="text.secondary">
                    {viewingPriceList.priceListCode}
                  </Typography>
                </Box>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, backgroundColor: 'rgba(83, 109, 254, 0.05)' }}>
                  <Typography variant="caption" color="text.secondary">Price List Type</Typography>
                  <Box sx={{ mt: 1 }}>
                    <Chip 
                      label={viewingPriceList.priceListType} 
                      color={getTypeColor(viewingPriceList.priceListType)}
                    />
                  </Box>
                </Paper>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, backgroundColor: 'rgba(83, 109, 254, 0.05)' }}>
                  <Typography variant="caption" color="text.secondary">Discount</Typography>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1 }}>
                    <PercentIcon sx={{ color: 'success.main' }} />
                    <Typography variant="body1" fontWeight="bold" color="success.main">
                      {viewingPriceList.discount}%
                    </Typography>
                  </Box>
                </Paper>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, backgroundColor: 'rgba(83, 109, 254, 0.05)' }}>
                  <Typography variant="caption" color="text.secondary">Valid From</Typography>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1 }}>
                    <CalendarIcon sx={{ color: 'primary.main' }} />
                    <Typography variant="body1" fontWeight="bold">
                      {viewingPriceList.validFrom}
                    </Typography>
                  </Box>
                </Paper>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, backgroundColor: 'rgba(83, 109, 254, 0.05)' }}>
                  <Typography variant="caption" color="text.secondary">Valid To</Typography>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1 }}>
                    <CalendarIcon sx={{ color: 'primary.main' }} />
                    <Typography variant="body1" fontWeight="bold">
                      {viewingPriceList.validTo}
                    </Typography>
                  </Box>
                </Paper>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, backgroundColor: 'rgba(83, 109, 254, 0.05)' }}>
                  <Typography variant="caption" color="text.secondary">Products Using This Price List</Typography>
                  <Typography variant="body1" fontWeight="bold" color="primary">
                    {viewingPriceList.productCount} Products
                  </Typography>
                </Paper>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, backgroundColor: 'rgba(83, 109, 254, 0.05)' }}>
                  <Typography variant="caption" color="text.secondary">Currency</Typography>
                  <Typography variant="body1" fontWeight="bold">
                    {viewingPriceList.currency}
                  </Typography>
                </Paper>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, backgroundColor: 'rgba(83, 109, 254, 0.05)' }}>
                  <Typography variant="caption" color="text.secondary">Rounding Method</Typography>
                  <Typography variant="body1" fontWeight="bold">
                    {viewingPriceList.roundingMethod}
                  </Typography>
                </Paper>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, backgroundColor: 'rgba(83, 109, 254, 0.05)' }}>
                  <Typography variant="caption" color="text.secondary">Priority</Typography>
                  <Typography variant="body1" fontWeight="bold">
                    {viewingPriceList.priority}
                  </Typography>
                </Paper>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, backgroundColor: 'rgba(83, 109, 254, 0.05)' }}>
                  <Typography variant="caption" color="text.secondary">Default Price List</Typography>
                  <Box sx={{ mt: 1 }}>
                    {viewingPriceList.isDefault ? (
                      <Chip icon={<StarIcon />} label="Yes" color="warning" />
                    ) : (
                      <Chip icon={<CancelIcon />} label="No" />
                    )}
                  </Box>
                </Paper>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, backgroundColor: 'rgba(83, 109, 254, 0.05)' }}>
                  <Typography variant="caption" color="text.secondary">Status</Typography>
                  <Box sx={{ mt: 1 }}>
                    <Chip
                      label={viewingPriceList.status}
                      sx={{
                        ...getStatusStyle(viewingPriceList.status),
                        fontWeight: 600,
                      }}
                    />
                  </Box>
                </Paper>
              </Grid>
              
              <Grid item xs={12}>
                <Paper sx={{ p: 2, backgroundColor: 'rgba(83, 109, 254, 0.05)' }}>
                  <Typography variant="caption" color="text.secondary">Description</Typography>
                  <Typography variant="body1" sx={{ mt: 1 }}>
                    {viewingPriceList.description || 'No description available'}
                  </Typography>
                </Paper>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, backgroundColor: 'rgba(144, 19, 254, 0.05)' }}>
                  <Typography variant="caption" color="text.secondary">Created Date</Typography>
                  <Typography variant="body1" fontWeight="bold">
                    {viewingPriceList.createdDate}
                  </Typography>
                </Paper>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, backgroundColor: 'rgba(144, 19, 254, 0.05)' }}>
                  <Typography variant="caption" color="text.secondary">Last Updated</Typography>
                  <Typography variant="body1" fontWeight="bold">
                    {viewingPriceList.updatedDate}
                  </Typography>
                </Paper>
              </Grid>
            </Grid>
          )}
        </DialogContent>
        <DialogActions sx={{ padding: '16px 24px' }}>
          <Button onClick={handleCloseViewModal}>Close</Button>
          {viewingPriceList && (
            <Button
              variant="contained"
              onClick={() => {
                handleCloseViewModal();
                handleEdit(viewingPriceList);
              }}
              startIcon={<EditIcon />}
              sx={{
                backgroundColor: 'primary.main',
                '&:hover': {
                  backgroundColor: 'primary.dark',
                },
              }}
            >
              Edit Price List
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default PriceListMaster;

